import clsx from 'clsx'

import { Container } from './Container'
import { Expandable } from './Expandable'


const testimonials = [
  [
    {
      content:
        "We worked with Datopian since 2017 as providers of Perth & Kinross Council’s first Open Data Portal. The portal met all our requirements, was reliable, and performed well. We had a good working relationship with Datopian throughout and found their service to be responsive, effective, and delivered professionally.",
      author: {
        name: 'Ewan Walker',
        role: 'Data Services Team Leader at <a href="https://www.pkc.gov.uk" target="_blank"><span>Perth & Kinross Council</span></a>',
        image: 'assets/images/pages/showcase/Ewan-Walker.jpg',
      },
    },
    {
      content:
        'The ability of CKAN to grow with us as we mature is critical and one of the main reasons we chose it.',
      author: {
        name: 'Marty Hall',
        role: 'Senior Information Technology Manager at <a href="https://www.gatesfoundation.org/" target="_blank"><span>Bill & Melinda Gates Foundation</span></a>',
        image: 'assets/images/pages/showcase/marty-hall.jpg',
      },
    },
    {
      content:
        'Simplicity is key. I’ve worked with other systems [than CKAN] to publish data that were very onerous to use and very off-putting from that perspective.',
      author: {
        name: 'Cormac McConaghy',
        role: 'CT Lead at <a href="https://www.opendatani.gov.uk/" target="_blank"><span>Open Data Northern Ireland </span></a>',
        image: 'assets/images/pages/showcase/Cormac-McConaghy.png',
      },
    },

  ],
  [
    {
      content:
        'Things like DCAT metadata standards, and making it as simple as possible for an organisation to take a dataset and put it on the portal, was very much the original idea around using CKAN.',
      author: {
        name: 'Cormac McConaghy',
        role: 'CT Lead at <a href="https://www.opendatani.gov.uk/" target="_blank"><span>Open Data Northern Ireland </span></a>',
        image: 'assets/images/pages/showcase/Cormac-McConaghy.png',
      },
    },
    {
      content:
        'CKAN has been a great success for National Grid, it has delivered a lot.',
      author: {
        name: 'Nikhil Madani',
        role: 'Data Platforms Product Manager at <a href="https://www.nationalgrideso.com/" target="_blank"><span>National Grid ESO</span></a>',
        image: 'assets/images/pages/showcase/Nikhil-Madani.jpg',
      },
    },

    {
      content:
        "CKAN is quite flexible, It integrates with new technologies fast, and we've been able to show that to stakeholders, both internally and externally.",
      author: {
        name: 'Nikhil Madani',
        role: 'Data Platforms Product Manager at <a href="https://www.nationalgrideso.com/" target="_blank"><span>National Grid ESO</span></a>',
        image: 'assets/images/pages/showcase/Nikhil-Madani.jpg',
      },
    },
    {
      content:
        "I would like to take this opportunity to extend my heartfelt gratitude for the outstanding support and collaboration your team has offered over the past year. The agility, technical prowess, and steadfast dedication you have demonstrated are truly commendable. Your efforts have been integral to our successes, and I am deeply appreciative. I am hopeful that there will be opportunities for me to engage with future projects and contribute. Thank you once again for your exemplary contribution and for the positive spirit you bring to our work.",
      author: {
        name: 'Shailesh Kumar',
        role: 'Analytics and Data Architect at <a href="https://www.ssen.co.uk/" target="_blank"><span>SSEN</span></a>',
        image: 'assets/images/pages/showcase/ssen-logo.png',
      },
    },
  ],
  [
    {
      content:
        'We’re working on a CKAN platform for all our datasets - and it has been a strategic choice to use CKAN.',
      author: {
        name: 'Heidi Bøjlesen',
        role: ' IT Project Manager at <a href="https://energinet.dk/" target="_blank"><span>Energinet</span></a>',
        image: 'assets/images/pages/showcase/Heidi-Bøjlesen.jpg',
      },
    },
    {
      content:
        'We looked at CKAN as a good benchmark to work towards.',
      author: {
        name: 'Jonathan Challener',
        role: 'Partnerships and Community Manager at <a href="https://www.oecd.org/ "target="_blank"><span>OECD</span></a>',
        image: 'assets/images/pages/showcase/Jonathan-Challener.jpg',
      },
    },
    {
      content:
        'It truly is that simple - we don’t want it to be another level of complexity to what they [our civil servants] do, we don’t want it to take 10 minutes to publish.',
      author: {
        name: 'Cormac McConaghy',
        role: 'CT Lead at <a href="https://www.opendatani.gov.uk/" target="_blank"><span>Open Data Northern Ireland </span></a>',
        image: 'assets/images/pages/showcase/Cormac-McConaghy.png',
      },
    },
    {
      content:
        'The sheer flexibility and the open-source nature of CKAN was appealing.',
      author: {
        name: 'Doug Young',
        role: ' Development Officer at <a href="https://scottishcities.org.uk/" target="_blank"><span>Scottish Cities Alliance</span></a>',
        image: 'assets/images/pages/showcase/Doug-Young.jpg',
      },
    },
  ],
]

function Testimonial({ author, children }) {
  return (
    <figure className="rounded-4xl p-8 shadow-md ring-1 ring-slate-900/5" tabIndex={0}>
      <blockquote>
        <p className="text-lg tracking-tight text-slate-900 main-text">
          {children}
        </p>
      </blockquote>
      <figcaption className="mt-6 flex items-center">
        <div className="md:w-fit xl:w-[20%] w-[20%] ">
          <div className='overflow-hidden rounded-full w-fit  bg-slate-50'>
            <img
              className="w-8 h-8 md:h-12 md:w-12 object-cover"
              src={author.image}
              alt={author.name}
              width={48}
              height={48}
            />
          </div>

        </div>
        <div className="ml-4 md:w-fit xl:w-[80%] w-[80%]">
          <div className="text-base font-['Inter'] font-medium leading-6 tracking-tight text-slate-900">
            {author.name}
          </div>
          <div className="descp mt-1 text-sm text-slate-600  font-['Inter'] " dangerouslySetInnerHTML={{ __html: author.role }}></div>
        </div>
      </figcaption>
    </figure>
  )
}

export function Testimonials() {
  return (
    <section className="py-8 sm:py-10 lg:py-16 px-8 sm:px-0 mx-auto xl:max-w-7xl lg:max-w-5xl md:max-w-3xl w-full rounded-md" aria-label='Testimonial Section' tabIndex={0}>
      <Expandable>
        {({ isExpanded }) => (
          <>
            <ul
              role="list"
              className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-8 px-4 lg:max-w-7xl lg:grid-cols-3 lg:px-8 "
              aria-roledescription='testimonial'
            >
              {testimonials
                .map((column) => column[0])
                .map((testimonial, testimonialIndex) => (
                  <li key={testimonialIndex} className="lg:hidden">
                    <Testimonial author={testimonial.author}>
                      {testimonial.content}
                    </Testimonial>
                  </li>
                ))}
              {testimonials.map((column, columnIndex) => (
                <li
                  key={columnIndex}
                  className={isExpanded ? undefined : 'hidden lg:list-item'}
                >
                  <ul role="list">
                    {column
                      .slice(0, isExpanded ? undefined : 3)
                      .map((testimonial, testimonialIndex) => (
                        <li
                          key={testimonialIndex}
                          className={clsx(
                            testimonialIndex === 0 && 'hidden lg:list-item',
                            testimonialIndex === 1 && 'lg:mt-8 ',
                            testimonialIndex > 1 && 'mt-8',
                          )}
                        >
                          <Testimonial author={testimonial.author}>
                            {testimonial.content}
                          </Testimonial>
                        </li>
                      ))}
                  </ul>
                </li>
              ))}
            </ul>
            <Expandable.Button>Read more testimonials</Expandable.Button>
          </>
        )}
      </Expandable>
    </section>
  )
}
